export const CARD_RADIUS_PX = 12
export const MEDIA_INSET_MOBILE_PX = 12
export const MEDIA_INSET_DESKTOP_PX = 14
export const CARD_BACKGROUND = 'hsl(var(--card))'

